import React, { Component } from "react";
import { Grid, Card, Table, Button, Form, Tag } from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import Crud_Catalogos from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";

class IpWhitelistGlobalPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ips: [],
      cidr: "",
      descripcion: "",
      activo: true,
      loading: false,
    };
  }

  componentDidMount() {
    this.cargarIps();
  }

  cargarIps = () => {
    this.setState({ loading: true });
    Crud_Catalogos("ip-whitelist/global", "", "get", "", [])
      .then((res) => this.setState({ ips: res || [], loading: false }))
      .catch(() => {
        NotificationManager.error("Error al cargar IPs globales");
        this.setState({ loading: false });
      });
  };

  agregarIp = (e) => {
    e.preventDefault();
    const { cidr, descripcion, activo } = this.state;
    if (!cidr.trim()) {
      NotificationManager.warning("El campo CIDR es obligatorio");
      return;
    }
    Crud_Catalogos("ip-whitelist/global", "", "post", "", {
        cidr: cidr.trim(),
        descripcion: descripcion.trim(),
        activo,
      })
      .then(() => {
        NotificationManager.success("IP agregada correctamente");
        this.setState({ cidr: "", descripcion: "", activo: true });
        this.cargarIps();
      })
      .catch(() => {
        NotificationManager.error("Error al agregar IP");
      });
  };

  eliminarIp = (id) => {
    if (!window.confirm("¿Eliminar esta IP?")) return;
    Crud_Catalogos("ip-whitelist/global/" + id, "", "delete", "")
      .then(() => {
        NotificationManager.success("IP eliminada");
        this.cargarIps();
      })
      .catch(() => NotificationManager.error("Error al eliminar IP"));
  };

  refrescarCache = () => {
    Crud_Catalogos("ip-whitelist/global/refrescar-cache", "", "post", "", {})
      .then(() => NotificationManager.success("Caché refrescado"))
      .catch(() => NotificationManager.error("Error al refrescar caché"));
  };

  render() {
    const { ips, cidr, descripcion, activo, loading } = this.state;
    return (
      <SiteWrapper>
        <div className="container mt-3">
          <Grid.Row>
            <Grid.Col sm={12} lg={5}>
              <Card>
                <Card.Header>
                  <Card.Title>Agregar IP Global</Card.Title>
                </Card.Header>
                <Card.Body>
                  <form onSubmit={this.agregarIp}>
                    <Form.Group label="CIDR / IP">
                      <Form.Input
                        placeholder="Ej: 192.168.1.0/24 o 10.0.0.1"
                        value={cidr}
                        onChange={(e) => this.setState({ cidr: e.target.value })}
                      />
                    </Form.Group>
                    <Form.Group label="Descripción">
                      <Form.Input
                        placeholder="Descripción de la IP"
                        value={descripcion}
                        onChange={(e) => this.setState({ descripcion: e.target.value })}
                      />
                    </Form.Group>
                    <Form.Group label="">
                      <Form.Checkbox
                        label="Activo"
                        checked={activo}
                        onChange={(e) => this.setState({ activo: e.target.checked })}
                      />
                    </Form.Group>
                    <Button color="primary" type="submit" block>
                      Agregar
                    </Button>
                  </form>
                </Card.Body>
              </Card>
            </Grid.Col>

            <Grid.Col sm={12} lg={7}>
              <Card>
                <Card.Header>
                  <Card.Title>IP Whitelist Global</Card.Title>
                  <Card.Options>
                    <Button
                      color="secondary"
                      size="sm"
                      onClick={this.refrescarCache}
                      icon="refresh-cw"
                    >
                      Refrescar Caché
                    </Button>
                  </Card.Options>
                </Card.Header>
                {loading ? (
                  <Card.Body>Cargando...</Card.Body>
                ) : (
                  <Table
                    cards
                    striped
                    responsive
                    className="table-vcenter"
                  >
                    <Table.Header>
                      <Table.Row>
                        <Table.ColHeader>ID</Table.ColHeader>
                        <Table.ColHeader>CIDR</Table.ColHeader>
                        <Table.ColHeader>Descripción</Table.ColHeader>
                        <Table.ColHeader>Activo</Table.ColHeader>
                        <Table.ColHeader>Fecha Creación</Table.ColHeader>
                        <Table.ColHeader>Acciones</Table.ColHeader>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {ips.map((ip) => (
                        <Table.Row key={ip.id}>
                          <Table.Col>{ip.id}</Table.Col>
                          <Table.Col><strong>{ip.cidr}</strong></Table.Col>
                          <Table.Col>{ip.descripcion}</Table.Col>
                          <Table.Col>
                            <Tag color={ip.activo ? "green" : "red"}>
                              {ip.activo ? "Sí" : "No"}
                            </Tag>
                          </Table.Col>
                          <Table.Col>
                            {ip.fechaCreacion
                              ? new Date(ip.fechaCreacion).toLocaleString()
                              : ""}
                          </Table.Col>
                          <Table.Col>
                            <Button
                              color="danger"
                              size="sm"
                              icon="trash-2"
                              onClick={() => this.eliminarIp(ip.id)}
                            />
                          </Table.Col>
                        </Table.Row>
                      ))}
                      {ips.length === 0 && (
                        <Table.Row>
                          <Table.Col colSpan={6} alignContent="center">
                            No hay IPs registradas
                          </Table.Col>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                )}
              </Card>
            </Grid.Col>
          </Grid.Row>
        </div>
      </SiteWrapper>
    );
  }
}

export default IpWhitelistGlobalPage;
